/** Modos de visualizações dos leads nas campanhas */
export interface CampanhaLeadVisualizacaoModo {
    id: number;
    nome: string;
    iconClass?: string;
}

export const campanhaLeadVisualizacaoModoOrigens: CampanhaLeadVisualizacaoModo = {
    id: 1,
    nome: 'Cadastrados'
};
export const campanhaLeadVisualizacaoModoQualificacoes: CampanhaLeadVisualizacaoModo = {
    id: 2,
    nome: 'Qualificados'
};
export const campanhaLeadVisualizacaoModoAmbos: CampanhaLeadVisualizacaoModo = {
    id: 3,
    nome: 'Ambos'
};

export const campanhaLeadVisualizacaoModos: CampanhaLeadVisualizacaoModo[] = [
    campanhaLeadVisualizacaoModoOrigens,
    campanhaLeadVisualizacaoModoQualificacoes,
    campanhaLeadVisualizacaoModoAmbos
];

/** Verifica se o modo de visualização das campanhas dos leads é pelas origens */
export function isCampanhaLeadVisualizacaoModoOrigens(modo: number): boolean {
    return modo === campanhaLeadVisualizacaoModoOrigens.id;
}

/** Verifica se o modo de visualização das campanhas dos Lead é pelas qualificações */
export function isCampanhaLeadVisualizacaoModoQualificacoes(modo: number): boolean {
    return modo === campanhaLeadVisualizacaoModoQualificacoes.id;
}

/** Verifica se o modo de visualização das campanhas dos Lead é ambos */
export function isCampanhaLeadVisualizacaoModoAmbos(modo: number): boolean {
    return modo === campanhaLeadVisualizacaoModoAmbos.id;
}
